import { gql } from 'apollo-angular';

export const GET_ALL_REFUNDS_WITH_PAGINATION = gql`
  query findAllRefundsWithPagination($input: RefundPaginationInput) {
    findAllRefundsWithPagination(input: $input) {
      refunds {
        id
        referenceNumber
        refundStatus
        refundDate
        amount
        customerData {
          id
          firstName
          lastName
        }
        accountData {
          id
          accountName
        }
        journalData {
          id
          journalNo
        }
        invoiceData {
          id
          invoiceNo
        }
        currencyData {
          id
          currencyCode
        }
        employeeData {
          id
          firstName
          lastName
        }
      }
      total
      skip
      limit
    }
  }
`;

export const GET_ALL_VENDOR_INVOICES = gql`
  query findAllBillsWithPagination($input: BillPaginationInput) {
    findAllBillsWithPagination(input: $input) {
      bills {
        id
        billNo
        billStatus
        vendorData {
          id
          vendorName
        }
        accountId
        billDate
        dueDate
        subTotal
        tax
        totalAmount
        balance
        paidDate
      }
      total
      skip
      limit
    }
  }
`;

export const LIST_VENDORS = gql`
  query vendors($search: String) {
    vendors(search: $search) {
      id
      vendorName
    }
  }
`;

export const LIST_ACCOUNTS = gql`
  query findAccountsByType($accountType: AccountType!) {
    findAccountsByType(accountType: $accountType) {
      id
      accountType
      accountName
      accountCode
    }
  }
`;

// export const LIST_PAID_INVOICES = gql`
//   query getPaidInvoices {
//     getPaidInvoices {
//       id
//       invoiceNo
//       paymentStatus
//       totalAmount
//       balance
//       paymentInfos {
//         paymentData {
//           paymentStatus
//           amount
//         }
//       }
//       customerData {
//         id
//         firstName
//         lastName
//       }
//     }
//   }
// `;

export const LIST_PAID_INVOICES = gql`
  query getPaidInvoices($customerId: Int!, $search: String) {
    getPaidInvoices(customerId: $customerId, search: $search) {
      id
      invoiceNo
      paymentStatus
      totalAmount
      balance
      paymentInfos {
        paymentData {
          paymentStatus
          amount
        }
      }
      customerData {
        id
        firstName
        lastName
      }
    }
  }
`;

export const ACCOUNTS = gql`
  query accounts($search: String) {
    accounts(search: $search) {
      id
      accountName
    }
  }
`;

export const GET_REFUND_BY_ID = gql`
  query refund($id: Int!) {
    refund(id: $id) {
      id
      invoiceId
      customerId
      invoiceData {
        invoiceNo
      }
      customerData {
        id
        firstName
        lastName
      }
      employeeData {
        id
        firstName
      }
      amount
      refundUrl
      currencyId
      refundDate
      paymentMethod
      accountId
      referenceNumber
      notes
      isCheque
      chequeNo
      chequeDate
      refundStatus
      isApproved
      approverId
      createdAt
      updatedAt
      deletedAt
    }
  }
`;


